<template>
  <div class="order-page">
    <el-card class="box-card">
      <el-form :model="form"
               :rules="rules"
               style="width: 100%"
               label-width="110px"
               size="small">
        <el-row>
          <el-col :span="6">
            <el-form-item prop="trade_from"
                          label="平台">
              <el-select clearable
                         v-model="form.trade_from"
                         placeholder="请选择"
                         style="width: 80%">
                <el-option v-for="item in tradefrom"
                           :key="item.id"
                           :label="item.name"
                           :value="item.code">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="platCode"
                          label="行业">
              <el-select clearable
                         v-model="form.profession"
                         placeholder="请选择"
                         style="width: 80%">
                <el-option v-for="item in platlists"
                           :key="item.id"
                           :label="item.name"
                           :value="item.code">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="business"
                          label="商家">
              <el-select v-loading="ptnListLoading"
                         clearable
                         v-model="form.business"
                         placeholder="请选择"
                         style="width: 80%">
                <el-option v-for="item in ptnlists"
                           :key="item.id"
                           :label="item.name"
                           :value="item.code">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="store"
                          label="店铺">
              <el-select v-loading="shopListLoading"
                         clearable
                         v-model="form.store"
                         placeholder="请选择"
                         style="width: 80%">
                <el-option v-for="item in shoplists"
                           :key="item.id"
                           :label="item.name"
                           :value="item.code">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="tid"
                          label="订单号">
              <el-input v-model="form.tid"
                        style="width: 80%"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="sku"
                          label="SKU">
              <el-input v-model="form.sku"
                        style="width: 80%"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item prop="payment"
                          label="订单实付金额"
                          label-width="110px">
              <!-- <el-input v-model="form.payment"></el-input> -->
              <!-- <el-row>
                <el-col :span="11">
                  <el-input type="number" v-model.number="form.payment1"></el-input>
                </el-col>
                <el-col :span="2" style="text-align: center;">~</el-col>
                <el-col :span="11">
                  <el-input type="number" v-model.number="form.payment2"></el-input>
                </el-col>
              </el-row>-->
              <number-range v-model="form.payment"
                            style="width: 80%" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="trade_status"
                          label="订单状态">
              <el-select clearable
                         v-model="form.trade_status"
                         placeholder="请选择"
                         style="width: 80%">
                <el-option v-for="item in tradestatus"
                           :key="item.id"
                           :label="item.name"
                           :value="item.code">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="oid"
                          label="子订单号">
              <el-input v-model="form.oid"
                        style="width: 80%"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="title"
                          label="商品名">
              <el-input v-model="form.title"
                        style="width: 80%"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="created"
                          label="下单时间">
              <el-date-picker v-model="form.created"
                              type="datetimerange"
                              range-separator="至"
                              start-placeholder="开始日期"
                              end-placeholder="结束日期"
                              value-format="yyyy-MM-dd HH:mm:ss"
                              :default-time="['00:00:00', '23:59:59']"
                              style="width: 80%"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-show="searchAreaStatus">
          <el-col>
            <el-row>

              <el-col :span="8">
                <el-form-item prop="pay_time"
                              label="付款时间">
                  <el-date-picker v-model="form.pay_time"
                                  type="datetimerange"
                                  range-separator="至"
                                  start-placeholder="开始日期"
                                  end-placeholder="结束日期"
                                  value-format="yyyy-MM-dd HH:mm:ss"
                                  :default-time="['00:00:00', '23:59:59']"
                                  style="width: 80%"></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item prop="consign_time"
                              label="发货时间">
                  <el-date-picker v-model="form.consign_time"
                                  type="datetimerange"
                                  range-separator="至"
                                  start-placeholder="开始日期"
                                  end-placeholder="结束日期"
                                  value-format="yyyy-MM-dd HH:mm:ss"
                                  :default-time="['00:00:00', '23:59:59']"
                                  style="width: 80%"></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item prop="end_time"
                              label="交易完成时间"
                              label-width="120px">
                  <el-date-picker v-model="form.end_time"
                                  type="datetimerange"
                                  range-separator="至"
                                  start-placeholder="开始日期"
                                  end-placeholder="结束日期"
                                  value-format="yyyy-MM-dd HH:mm:ss"
                                  :default-time="['00:00:00', '23:59:59']"
                                  style="width: 80%"></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col>

          </el-col>

        </el-row>
      </el-form>
    </el-card>
    <el-card class="button-box">
      <action-line @action-line="handleActionLine"
                   :list="actionLineWithoutImport">
        <el-button @click="searchAreaStatus = !searchAreaStatus">{{ searchAreaStatus ? "收起" : "展开"}}</el-button>
      </action-line>
    </el-card>

    <el-table v-loading="loading"
              height="calc(100vh - 100px)"
              class="main-table"
              border
              :data="tableData">
      <el-table-column align="center"
                       header-aligin="center"
                       prop="tid"
                       label="订单号"
                       width="180px"></el-table-column>
      <el-table-column align="center"
                       header-aligin="center"
                       prop="oid"
                       label="子订单号"
                       width="180px"></el-table-column>
      <el-table-column align="center"
                       header-aligin="center"
                       prop="title"
                       label="商品名"
                       width="230px"
                       show-overflow-tooltip></el-table-column>
      <el-table-column align="center"
                       header-aligin="center"
                       prop="sku"
                       label="SKU"
                       width="130px"></el-table-column>
      <el-table-column align="center"
                       header-aligin="center"
                       prop="divide_order_fee"
                       label="商品实付金额"
                       show-overflow-tooltip></el-table-column>
      <el-table-column align="center"
                       header-aligin="center"
                       prop="payment"
                       label="订单实付金额"
                       show-overflow-tooltip></el-table-column>
      <el-table-column align="center"
                       header-aligin="center"
                       prop="trade_status"
                       label="订单状态"
                       width="220px"></el-table-column>
      <el-table-column align="center"
                       header-aligin="center"
                       prop="created"
                       label="下单时间"
                       width="160px"></el-table-column>
      <el-table-column align="center"
                       header-aligin="center"
                       prop="pay_time"
                       label="付款时间"
                       width="160px"></el-table-column>
      <el-table-column align="center"
                       header-aligin="center"
                       prop="trade_from"
                       label="平台"></el-table-column>
      <el-table-column align="center"
                       header-aligin="center"
                       prop="profession"
                       label="行业"
                       show-overflow-tooltip></el-table-column>
      <el-table-column align="center"
                       header-aligin="center"
                       prop="business"
                       label="商家"
                       show-overflow-tooltip></el-table-column>
      <el-table-column align="center"
                       header-aligin="center"
                       prop="store"
                       label="店铺"
                       min-width="110px"
                       show-overflow-tooltip></el-table-column>
    </el-table>
    <el-card style="padding:0"
             class="pagation-card">
      <el-row class="pagation-row">
        <el-pagination background
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page.sync="queryPrdlists.pagenum"
                       :page-size="queryPrdlists.pagesize"
                       :page-sizes="[10, 20, 50, 100]"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="total"></el-pagination>
      </el-row>
    </el-card>
    <export-dialog ref="refExportDialog"
                   @submit="exportSubmit" />
  </div>
</template>

<script>
import XLSX from 'xlsx'
import SearchMixin from '@/common/mixins/search-mixin'
import ActionLine from '@/common/mixins/action-line'
import handleExport from '@/common/mixins/handle-export'
import { dealReturn } from '@/common/js/index.js'
import { numberCompare, isNumber } from '@/utils'
import {
  getplatlists,
  getptnlists,
  getshoplists,
  gettradestatus,
  gettradefrom,
} from '@/common/mixins/select'
// import { tradelist_api } from "./desc";
import * as Desc from './desc'
import { form, rules } from './data'
export default {
  mixins: [
    ActionLine,
    SearchMixin,
    getplatlists,
    getptnlists,
    getshoplists,
    gettradestatus,
    gettradefrom,
    handleExport,
  ],
  data() {
    return {
      form: JSON.parse(JSON.stringify(form)),
      platlists: [],
      loading: false,
      tableData: [],
      fileList: [],
      provinceList: [],
      Desc,
      rules,
      exportForm: {},
      // payment1: "",
      // payment2: "",
    }
  },
  created() {
    // this.getTableData();
  },
  methods: {
    // 可以像 订单页这样重写 searchMixin 内的方法 达到自定义的目的
    // handleSearch() {
    //   // if (this.form.payment2 === "") this.form.payment2 === 0;
    //   // if (this.form.payment2 === "") this.form.payment2 === 0;
    //   // if (!this._isLarge(this.form.payment2, this.form.payment1)) return;
    //   this.form.payment = [this.form.payment1, this.form.payment2];
    //   this._collectQuery();
    //   this.getTableData();
    // },
    // async getTableData() {
    //   this.loading = true;
    //   let { data, err } = await this.axiosApi(
    //     Desc.tradelist_api,
    //     this.queryPrdlists
    //   );
    //   // console.log("data", data);
    //   this.loading = false;
    //   console.log("data", data);
    //   this.tableData = data.data.data.data;
    //   this.total = parseInt(data.data.data.total);
    //   dealReturn(data, err);
    // },
    // _isLarge(paymentUpper, paymentLower) {
    //   if (paymentUpper === "") paymentUpper = 0;
    //   if (paymentLower === "") paymentLower = 0;
    //   if (parseInt(paymentUpper) < parseInt(paymentLower)) {
    //     this.$message({
    //       type: "error",
    //       message: `下限不能大于上限`,
    //     });
    //     return false;
    //   }
    //   return true;
    // },
  },
}
</script>

<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 22px;
}
// .pagation-card >>> {
// }
// .el-table {
//   height: calc(100vh - 100px);
// }
</style>


// WEBPACK FOOTER //
// src/views/base/trade/index.vue